import React, { useEffect, useState } from "react";
import { Card, Col, Flex, Table, Typography } from "antd";

import PageTitle from "../../components/PageTitle";
import IntlMessage from "../../components/IntlMessage";
import _ from "lodash";
import dayjs from "dayjs";
import seatLockApi from "../../api/seat-lock";
import useTime from "../../hooks/useTime";

const { Text, Link } = Typography;

const SeatLocked = () => {
  const [loading, setLoading] = useState(false);
  const [seatLock, setSeatLock] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [total, setTotal] = useState(1);
  const [condition, setCondition] = useState({});
  const [refresh, setRefresh] = useState(false);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    order_by: "id",
    order_dir: "DESC",
    keyword: "",
  });

  const { convertToAnyTimezone } = useTime();

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  useEffect(() => {
    const fetch = async () => {
      try {
        setLoading(true);
        const getSeatLock = await seatLockApi.getAll(filter);
        setSeatLock(getSeatLock.data);
        setTotal(getSeatLock.total);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [refresh, filter]);

  useEffect(() => {
    if (filter?.filter_name && filter?.filter_value) {
      const newCondition = _.zipObjectDeep(
        filter?.filter_name,
        filter?.filter_value
      );
      console.log("newCondition: ", newCondition);
      setCondition(newCondition);
    }
  }, [filter]);

  const columns = [
    {
      title: <IntlMessage id="global.segments" />,
      key: "segment_id",
      width: 150,
      sorter: true,
      dataIndex: "segment_id",
      render: (text, record, index) => {
        return `${record?.segment?.start_stop?.title} - ${record?.segment?.end_stop?.title}`;
      },
    },
    {
      title: <IntlMessage id="order.depart_date" />,
      key: "seat",
      sorter: true,
      width: 250,
      dataIndex: "seat",
      render: (text, record, index) => {
        return <Text>{record.depart_date}</Text>;
      },
    },
    {
      title: <IntlMessage id="global.lock" />,
      key: "lock",
      sorter: true,
      width: 250,
      dataIndex: "lock",
      render: (text, record, index) => {
        return (
          <Text>
            {convertToAnyTimezone(record?.lock).format("DD/MM/YYYY HH:mm:ss")}
          </Text>
        );
      },
    },
    {
      title: <IntlMessage id="global.expiration" />,
      key: "expiration",
      sorter: true,
      width: 250,
      dataIndex: "expiration",
      render: (text, record, index) => {
        return (
          <Text>
            {convertToAnyTimezone(record?.expiration).format(
              "DD/MM/YYYY HH:mm:ss"
            )}
          </Text>
        );
      },
    },
    // {
    //   title: <IntlMessage id="global.status" />
    //   key: "order_status",
    //   sorter: true,
    //   width: 250,
    //   dataIndex: "order_status",
    //   render: (text, record, index) => {
    //     // return getTagOrderStatus(record);
    //   },
    // },
  ];

  const getOrder = (order) => {
    if (order === "ascend") return "ASC";
    if (order === "descend") return "DESC";
    return "DESC";
  };

  const onChangeTable = (pagination, filters, sorter) => {
    const currentFilter = {
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
    };

    if (sorter) {
      const { field, order } = sorter;
      console.log("field:", field);
      console.log("order:", order);
      if (field === "operator.short_name") {
        currentFilter.order_by = "operator";
      } else if (field === "payment_method.method") {
        currentFilter.order_by = "payment_method";
      } else {
        currentFilter.order_by = field || "id";
      }

      currentFilter.order_dir = getOrder(order);

      setFilter(currentFilter);
    }

    if (pagination.pageSize !== filter.page) {
      setSeatLock([]);
    }
  };

  return (
    <React.Fragment>
      <Flex justify="space-between" align="center">
        <Col>
          <PageTitle title={<IntlMessage id="global.seat_lock" />} />
        </Col>
      </Flex>

      <Card bordered={false}>
        <Flex vertical gap={8}>
          <Table
            columns={columns}
            tableLayout="auto"
            pagination={{
              limit: filter.limit,
              current: filter.page,
              total: total,
              showSizeChanger: true,
            }}
            size="small"
            onChange={onChangeTable}
            dataSource={seatLock}
            rowSelection={rowSelection}
            loading={loading}
            rowKey={"id"}
          />
        </Flex>
      </Card>
    </React.Fragment>
  );
};

export default SeatLocked;
